import React from "react";
import PropTypes from "prop-types";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import { ListItemButton } from "@mui/material";

class ListItemLink extends React.Component {
  renderLink = (itemProps) => <Link to={this.props.to} {...itemProps} />;

  render() {
    const { icon, primary } = this.props;
    return (
      /*<Box sx={{ width: "100%", maxWidth: 500 }}>
        <List>
          <ListItem>
            <ListItemButton onClick={this.renderLink}>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={primary} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>*/
      <ListItemButton component={this.renderLink}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={primary} />
      </ListItemButton>
    );
  }
}

ListItemLink.propTypes = {
  icon: PropTypes.node.isRequired,
  primary: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

export default ListItemLink;
